import { mergeMap, tap } from 'rxjs/operators';
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryRealtimeParamsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { selectKpisInStore, selectKpisPageLoading, selectKpisShowInitWaitingMessage } from '../_selectors/kpi.selectors';


export class KpisDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
        super();

		this.loading$ = this.store.pipe(
			select(selectKpisPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectKpisShowInitWaitingMessage)
        );
        
        this.store.pipe(
			select(selectKpisInStore),
		).subscribe((response: QueryRealtimeParamsModel) => {
			// this.paginatorTotalSubject.next(response.totalCount);			
			this.entitySubject.next(response.items);
		});

    }
}